/* nv.js — comportamento mínimo do markup portado do Prestige (sem o theme.js de origem). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var mq = function (q) { return window.matchMedia(q).matches; };

  /* ---------- diálogos: drawer, popover, header-search, modal ---------- */
  var TEMPLATES = { drawer: 'drawer-default-template', popover: 'popover-default-template', modal: 'modal-default-template', 'header-search': 'header-search-default-template' };
  function tipo(el) {
    if (el.tagName === 'HEADER-SEARCH') return 'header-search';
    if (el.classList.contains('drawer')) return 'drawer';
    if (el.classList.contains('popover')) return 'popover';
    if (el.classList.contains('modal')) return 'modal';
    return null;
  }
  function part(el, n) { return el.shadowRoot && el.shadowRoot.querySelector('[part~="' + n + '"]'); }
  function prepara(el) {
    if (el.shadowRoot) return;
    var id = el.getAttribute('template') || TEMPLATES[tipo(el)];
    var t = id && document.getElementById(id);
    if (!t) return;
    el.attachShadow({ mode: 'open' }).appendChild(t.content.cloneNode(true));
    var ov = part(el, 'overlay'); if (ov) ov.addEventListener('click', function () { fecha(el); });
    el.shadowRoot.addEventListener('click', function (e) { if (e.target.closest('[part~="close-button"]')) fecha(el); });
    el.addEventListener('click', function (e) { if (e.target.closest('dialog-close-button button')) fecha(el); });
  }
  var abertos = [];
  function abre(el, gatilho) {
    prepara(el);
    var t = tipo(el);
    if ((t === 'drawer' || t === 'modal') && el.parentElement !== document.body) document.body.appendChild(el);
    el.style.display = 'block'; el.setAttribute('open', '');
    abertos.push(el);
    if (gatilho) gatilho.setAttribute('aria-expanded', 'true');
    el._gatilho = gatilho;
    var c = part(el, 'content'), ov = part(el, 'overlay');
    if (t === 'drawer') {
      var esq = el.getAttribute('open-from') === 'left';
      if (c) { c.style.marginInlineStart = esq ? '0' : 'auto'; c.animate({ transform: [esq ? 'translateX(-100%)' : 'translateX(100%)', 'translateX(0)'] }, { duration: 300, easing: 'cubic-bezier(.645,.045,.355,1)' }); }
      if (ov) ov.animate({ opacity: [0, 1] }, { duration: 300 });
      document.documentElement.classList.add('lock');
    } else if (t === 'popover' && gatilho) {
      if (mq('screen and (min-width: 700px)')) { el.style.position = 'absolute'; }
    } else if (t === 'header-search') {
      var inp = $('input[type="search"]', el); if (inp) setTimeout(function () { inp.focus(); }, 50);
    }
  }
  function fecha(el) {
    var t = tipo(el), c = part(el, 'content');
    var fim = function () { el.style.display = ''; el.removeAttribute('open'); };
    if (t === 'drawer' && c) {
      var esq = el.getAttribute('open-from') === 'left';
      c.animate({ transform: ['translateX(0)', esq ? 'translateX(-100%)' : 'translateX(100%)'] }, { duration: 250 }).finished.then(fim);
    } else fim();
    if (el._gatilho) el._gatilho.setAttribute('aria-expanded', 'false');
    abertos = abertos.filter(function (x) { return x !== el; });
    if (!abertos.some(function (x) { return tipo(x) === 'drawer'; })) document.documentElement.classList.remove('lock');
  }
  document.addEventListener('click', function (e) {
    var g = e.target.closest('[aria-controls]');
    if (!g) return;
    var alvo = document.getElementById(g.getAttribute('aria-controls'));
    if (!alvo || !tipo(alvo)) return;           // cart-drawer inexistente: o link /cart segue (UpCart assume)
    e.preventDefault();
    alvo.hasAttribute('open') ? fecha(alvo) : abre(alvo, g);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && abertos.length) fecha(abertos[abertos.length - 1]); });
  document.addEventListener('click', function (e) {
    abertos.filter(function (x) { return tipo(x) === 'popover'; }).forEach(function (p) {
      if (!p.contains(e.target) && !(p._gatilho && p._gatilho.contains(e.target))) fecha(p);
    });
  }, true);

  /* ---------- menu lateral: sub-painéis ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.header-sidebar__linklist-button[aria-controls]');
    var voltar = e.target.closest('[data-action="close-panel"]');
    if (!b && !voltar) return;
    var sb = (b || voltar).closest('header-sidebar'); if (!sb) return;
    var col = $('.header-sidebar__collapsible-panel', sb);
    $$('.header-sidebar__sub-panel', sb).forEach(function (p) { p.hidden = true; });
    $$('.header-sidebar__main-panel [aria-expanded]', sb).forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
    if (b) {
      e.preventDefault();
      var p = document.getElementById(b.getAttribute('aria-controls'));
      if (p) { p.hidden = false; b.setAttribute('aria-expanded', 'true'); col && col.setAttribute('aria-activedescendant', p.id); col && (col.style.display = 'block');
        if (col) col.animate({ transform: ['translateX(-100%)', 'translateX(0)'], opacity: [0, 1] }, { duration: 250 }); }
    } else if (col) { col.removeAttribute('aria-activedescendant'); }
  });

  /* ---------- dropdown do header (hover no desktop) ---------- */
  $$('dropdown-menu-disclosure').forEach(function (dd) {
    var d = $('details', dd), s = $('summary', dd), t;
    if (!d) return;
    if (dd.getAttribute('trigger') === 'hover') {
      dd.addEventListener('mouseenter', function () { clearTimeout(t); d.open = true; d.setAttribute('aria-expanded', 'true'); });
      dd.addEventListener('mouseleave', function () { t = setTimeout(function () { d.open = false; d.setAttribute('aria-expanded', 'false'); }, 150); });
    }
    if (s && dd.hasAttribute('follow-summary-link')) s.addEventListener('click', function (e) {
      var u = s.getAttribute('data-follow-link');
      if (u && mq('(pointer: fine)')) { e.preventDefault(); location.href = u; }
    });
  });

  /* ---------- barra de anúncio ---------- */
  $$('announcement-bar-carousel').forEach(function (c) {
    var itens = $$(':scope > p', c); if (itens.length < 2) return;
    var i = 0, ir = function (n) { itens[i].classList.remove('is-selected'); i = (n + itens.length) % itens.length; itens[i].classList.add('is-selected'); };
    var tempo = (parseFloat(c.getAttribute('autoplay')) || 5) * 1000, timer = setInterval(function () { ir(i + 1); }, tempo);
    var reinicia = function () { clearInterval(timer); timer = setInterval(function () { ir(i + 1); }, tempo); };
    $$('carousel-prev-button[aria-controls="' + c.id + '"] button').forEach(function (b) { b.addEventListener('click', function () { ir(i - 1); reinicia(); }); });
    $$('carousel-next-button[aria-controls="' + c.id + '"] button').forEach(function (b) { b.addEventListener('click', function () { ir(i + 1); reinicia(); }); });
  });

  /* ---------- carrosséis por rolagem ---------- */
  function passo(c) { var f = c.firstElementChild; return f ? f.getBoundingClientRect().width + (parseFloat(getComputedStyle(c).columnGap) || 0) : c.clientWidth; }
  function carrosseis(raiz) { $$('scroll-carousel, [id^="carousel-"]', raiz).forEach(function (c) {
    if (c.tagName === 'ANNOUNCEMENT-BAR-CAROUSEL' || c.__nv) return; c.__nv = 1;
    var prev = $$('carousel-prev-button[aria-controls="' + c.id + '"] button'), next = $$('carousel-next-button[aria-controls="' + c.id + '"] button');
    var atualiza = function () {
      prev.forEach(function (b) { b.disabled = c.scrollLeft <= 2; });
      next.forEach(function (b) { b.disabled = c.scrollLeft + c.clientWidth >= c.scrollWidth - 2; });
    };
    prev.forEach(function (b) { b.addEventListener('click', function () { c.scrollBy({ left: -passo(c), behavior: 'smooth' }); }); });
    next.forEach(function (b) { b.addEventListener('click', function () { c.scrollBy({ left: passo(c), behavior: 'smooth' }); }); });
    c.addEventListener('scroll', atualiza, { passive: true }); atualiza();
  }); }
  carrosseis(document);

  /* ---------- abas das coleções em destaque (Charms / Mini Pouches) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('carousel-navigation button'); if (!b) return;
    var nav = b.closest('carousel-navigation'), alvo = document.getElementById(nav.getAttribute('aria-controls')); if (!alvo) return;
    var bs = $$('button', nav), i = bs.indexOf(b), itens = $$(':scope > .featured-collections-carousel__item', alvo);
    bs.forEach(function (x, k) { x.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    itens.forEach(function (x, k) { x.classList.toggle('is-selected', k === i); });
  });
  document.addEventListener('nv:conteudo', function (e) { carrosseis(e.detail && e.detail.el || document); });

  /* ---------- card de produto: swatch troca a foto; "+" abre o produto ---------- */
  document.addEventListener('change', function (e) {
    var r = e.target; if (!r.matches || !r.matches('product-card input[data-nv-p]')) return;
    var card = r.closest('product-card');
    var p = $('.product-card__image--primary', card), s = $('.product-card__image--secondary', card);
    var troca = function (img, url) { if (!img || !url) return; img.removeAttribute('srcset'); img.src = url; };
    troca(p, r.getAttribute('data-nv-p')); troca(s, r.getAttribute('data-nv-s'));
  });
  /* ícone de carrinho do card: adiciona a variante da cor marcada; sem variante disponível, abre o produto */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-nv-add]'); if (!b) return;
    e.preventDefault();
    var card = b.closest('product-card'), sw = card && card.querySelector('input[data-nv-v]:checked');
    var id = sw ? sw.getAttribute('data-nv-v') : b.getAttribute('data-nv-add');
    if (!id || (sw && sw.getAttribute('data-nv-ok') === 'false')) { location.href = b.getAttribute('data-nv-href'); return; }
    b.setAttribute('aria-busy', 'true');
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        b.removeAttribute('aria-busy');
        if (!res.ok) { location.href = b.getAttribute('data-nv-href'); return; }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: res.j.items || [res.j] } }));
        if (window.upcartOpenCart) { window.upcartOpenCart(); return; }
        if (!document.getElementById('upCart')) { location.href = '/cart'; }
      })
      .catch(function () { b.removeAttribute('aria-busy'); location.href = b.getAttribute('data-nv-href'); });
  });



  /* ---------- coleção: ordenar, filtrar, layout da grade ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('facets-sort-popover .popover__value-option[value]');
    if (o) { var u = new URL(location.href); u.searchParams.set('sort_by', o.getAttribute('value')); u.searchParams.delete('page'); location.href = u.toString(); return; }
    var b = e.target.closest('collection-layout-switch button[value]');
    if (b) {
      var sw = b.closest('collection-layout-switch'), lista = document.getElementById(sw.getAttribute('aria-controls'));
      $$('button', sw).forEach(function (x) { x.classList.toggle('is-active', x === b); });
      if (lista) lista.setAttribute(sw.getAttribute('device') === 'mobile' ? 'collection-mobile-layout' : 'collection-desktop-layout', b.value);
      return;
    }
    var fechar = e.target.closest('facets-drawer [slot="footer"] button');
    if (fechar) { var f = $('facets-drawer form'); if (f) envia(f); }
  });
  function envia(form) {
    var u = new URL(form.action, location.origin), fd = new FormData(form);
    var atual = new URL(location.href).searchParams.get('sort_by'); if (atual) u.searchParams.set('sort_by', atual);
    fd.forEach(function (v, k) { if (v !== '' && k !== 'page') u.searchParams.append(k, v); });
    location.href = u.toString();
  }
  $$('facets-form[update-on-change] form').forEach(function (f) { f.addEventListener('change', function () { envia(f); }); });

  /* ---------- PDP: variante, preço, galeria, carrinho ---------- */
  function dinheiro(c, fmt) {
    var v = (c / 100).toFixed(2), sem = v.replace(/\.00$/, '');
    return (fmt || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return Math.round(c / 100).toString();
      if (k === 'amount_with_comma_separator') return v.replace('.', ',');
      return v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    });
  }
  $$('[data-nv-pdp]').forEach(function (sec) {
    var form = document.getElementById(sec.getAttribute('data-form'));
    var picker = $('variant-picker', sec);
    var carr = $('scroll-carousel', sec);
    var fmt = sec.getAttribute('data-money');
    var variantes = []; try { variantes = JSON.parse($('[data-nv-variants]', sec).textContent); } catch (e) {}
    function irParaMidia(id, suave) {
      var alvo = id && $('.product-gallery__media[data-media-id="' + id + '"]', sec);
      if (carr && alvo) carr.scrollTo({ left: alvo.offsetLeft - carr.offsetLeft, behavior: suave ? 'smooth' : 'auto' });
      marcaThumb(id);
    }
    function marcaThumb(id) {
      $$('.product-gallery__thumbnail', sec).forEach(function (b) {
        var on = b.getAttribute('data-media-id') == id; b.setAttribute('aria-current', on ? 'true' : 'false');
        if (on) { var sc = b.parentElement; if (sc && sc.scrollTo) sc.scrollTo({ left: b.offsetLeft - sc.clientWidth / 2 + b.clientWidth / 2, top: b.offsetTop - sc.clientHeight / 2, behavior: 'smooth' }); }
      });
    }
    $$('.product-gallery__thumbnail', sec).forEach(function (b) { b.addEventListener('click', function () { irParaMidia(b.getAttribute('data-media-id'), true); }); });
    if (carr) {
      var t; carr.addEventListener('scroll', function () {
        clearTimeout(t); t = setTimeout(function () {
          var m = $$('.product-gallery__media', sec).reduce(function (a, el) { return Math.abs(el.offsetLeft - carr.offsetLeft - carr.scrollLeft) < Math.abs(a.offsetLeft - carr.offsetLeft - carr.scrollLeft) ? el : a; });
          $$('.product-gallery__media', sec).forEach(function (el) { el.classList.toggle('is-selected', el === m); });
          marcaThumb(m.getAttribute('data-media-id'));
        }, 120);
      }, { passive: true });
      var ini = $('.product-gallery__media.is-initial', sec); if (ini && ini !== carr.firstElementChild) setTimeout(function () { irParaMidia(ini.getAttribute('data-media-id')); }, 50);
    }
    if (picker && form) picker.addEventListener('change', function () {
      var sel = {}; $$('input[data-option-position]:checked', picker).forEach(function (i) { sel[i.getAttribute('data-option-position')] = i.value; });
      var v = variantes.filter(function (x) { return x.options.every(function (o, k) { return sel[k + 1] === undefined || sel[k + 1] === o; }); })[0];
      $$('[data-nv-option-label]', picker).forEach(function (s) { var k = s.getAttribute('data-nv-option-label'); if (sel[k]) s.textContent = sel[k]; });
      var btn = $('button[type="submit"]', form);
      if (!v) { if (btn) { btn.disabled = true; } return; }
      var ant = $('script[data-variant]', picker); var anterior = null; try { anterior = JSON.parse(ant.textContent); } catch (e) {}
      ant.textContent = JSON.stringify(v);
      form.querySelector('input[name="id"]').value = v.id;
      var pr = $('[data-nv-price]', sec), cp = $('[data-nv-compare]', sec);
      if (pr) pr.textContent = dinheiro(v.price, fmt);
      if (cp) { cp.textContent = dinheiro(v.compare_at_price || 0, fmt); cp.closest('compare-at-price').hidden = !(v.compare_at_price > v.price); }
      if (btn) { btn.disabled = !v.available; if (!v.available) btn.textContent = 'Sold out'; else if (/sold out/i.test(btn.textContent)) btn.textContent = 'Add to cart'; }
      if (v.featured_media) irParaMidia(v.featured_media.id, true);
      try { history.replaceState(null, '', location.pathname + '?variant=' + v.id); } catch (e) {}
      form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v, previousVariant: anterior } }));
    });
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('button[type="submit"]', form); if (btn) btn.setAttribute('aria-busy', 'true');
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (btn) btn.removeAttribute('aria-busy');
          if (!res.ok) { alert(res.j.description || res.j.message || 'Could not add to cart'); return; }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: [res.j] } }));
          // gaveta do carrinho = UpCart; sem ele instalado, cai na página do carrinho
          if (window.upcartOpenCart) { window.upcartOpenCart(); return; }
          if (!document.getElementById('upCart')) { location.href = '/cart'; return; }
        })
        .catch(function () { if (btn) btn.removeAttribute('aria-busy'); form.submit(); });
    });
    var z = $('[data-nv-zoom]', sec);
    if (z) z.addEventListener('click', function () {
      var m = $('.product-gallery__media.is-selected img', sec) || $('.product-gallery__media img', sec); if (!m) return;
      var o = document.createElement('div'); o.style.cssText = 'position:fixed;inset:0;z-index:10000;background:#fff;display:flex;align-items:center;justify-content:center;cursor:zoom-out';
      var i = new Image(); i.src = (m.currentSrc || m.src).replace(/width=\d+/, 'width=2000'); i.style.cssText = 'max-width:100%;max-height:100%;object-fit:contain';
      o.appendChild(i); o.addEventListener('click', function () { o.remove(); }); document.body.appendChild(o);
    });
  });

  /* ---------- alturas usadas pelo CSS (sticky) ---------- */
  function alturas() {
    var h = $('.shopify-section--header'), a = $('.shopify-section--announcement-bar');
    if (h) document.documentElement.style.setProperty('--header-height', h.clientHeight.toFixed(2) + 'px');
    if (a) document.documentElement.style.setProperty('--announcement-bar-height', a.clientHeight.toFixed(2) + 'px');
  }
  window.addEventListener('resize', alturas); alturas();

  /* ---------- rede de segurança: nada fica invisível se a animação de entrada falhar (WebKit) ---------- */
  setTimeout(function () { $$('.nv-reveal:not(.is-visible)').forEach(function (el) { el.classList.add('is-visible'); }); }, 3000);
})();
